module.exports = __webpack_public_path__ + "img/maybank-img.b9c0dc18.png";